import React from 'react';
import {displayBinaryResultText} from '../../utils/Test';

interface Props {
    result: any;
    hasMultipleResults?: boolean;
}

const BinaryResult: React.FC<Props> = (props) => {
    const {result, hasMultipleResults = false} = props;
    const metrics: {[index: string]: any} = {};

    return (
        <div className="w-full bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="space-y-6">
                {result.results?.map((r: any, index: any) => {
                    let displayMetric = false;

                    if (hasMultipleResults && !metrics[r.test_name]) {
                        displayMetric = true;
                        metrics[r.test_name] = true;
                    }

                    return (
                        <React.Fragment key={index}>
                            {index !== 0 && (!hasMultipleResults || displayMetric) && (
                                <div className="w-full h-px bg-gray-200"></div>
                            )}
                            {(!hasMultipleResults || displayMetric) && (
                                <div className="space-y-3">
                                    <p className="font-medium text-mld-text-primary">
                                        {result.results.length === 1 ? 'Result' : r.test_name}
                                    </p>
                                    <p className="text-gray-600">
                                        {displayBinaryResultText(r.result?.trim(), r.test_name)}
                                    </p>
                                </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default BinaryResult;
